import React, { Component } from 'react';
import { Modal, List, Button, Spin, Typography, Space, Badge, Empty } from 'antd';
import { ShoppingCartOutlined, CloseOutlined, CheckOutlined, WarningOutlined } from '@ant-design/icons';
import firebase from "../../firebase";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Text, Title } = Typography;

class MobileCartSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carts: [],
      loading: false,
    }
  }

  componentDidMount() {
    if (this.props.isOpen) {
      this.getCarts();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.getCarts();
    }
  }

  getCarts = async () => {
    const { db, user, org, userOrg, type } = this.props;
    if (!org || !user || !db) return;

    this.setState({ loading: true });

    let collection;
    // Determine the relevant items collection for price/existence checks
    if(org.reseller && userOrg && userOrg.maker) {
      collection = db.collection('items_stock').doc(userOrg.id).collection('buyers').doc(org.id).collection('items');
    } else if(org.maker && userOrg && userOrg.reseller) {
      collection = db.collection('items_stock').doc(org.id).collection('buyers').doc(userOrg.id).collection('items');
    } else if(org.reseller && userOrg && userOrg.buyer) {
      collection = db.collection('items_sell').doc(userOrg.id).collection('items');
    } else if(org.buyer && userOrg && userOrg.reseller) {
      collection = db.collection('items_sell').doc(org.id).collection('items');
    }

    const collectionName = type === 'otasuke' ? 'otasuke_carts' : 'carts';
    const cRef = db.collection(collectionName).doc(user.id).collection(collectionName).doc(org.id);
    
    try {
      const doc = await cRef.get();
      const cData = doc.data() || {};
      
      // Verification logic (existence, price, expiration)
      if (collection) {
        const cartIndices = Array.from({ length: 5 }, (_, i) => i);
        for (const i of cartIndices) {
          let cart = cData[i];
          if (cart && cart.items) {
            delete cart.deletedItem;
            delete cart.deletedText;
            
            await Promise.all(cart.items.map(async (item) => {
              const itemSell = await collection.doc(item.id).get();
              const itemSellData = itemSell.data();
              
              delete item.deletedItem;
              delete item.deletedText;

              if (!itemSellData) {
                cart.deletedItem = true;
                cart.deletedText = '販売終了商品が含まれています';
                item.deletedItem = true;
                item.deletedText = '販売終了商品が含まれています';
              } else if (!itemSellData.price || (itemSellData.price[0] && !itemSellData.price[0].price)) {
                cart.deletedItem = true;
                cart.deletedText = '要見積商品が含まれています';
                item.deletedItem = true;
                item.deletedText = '要見積商品が含まれています';
              } else if (itemSellData.price[0] && !itemSellData.price[0].expiration_date) {
                cart.deletedItem = true;
                cart.deletedText = '要見積商品が含まれています';
                item.deletedItem = true;
                item.deletedText = '要見積商品が含まれています';
              } else if (itemSellData.price[0] && itemSellData.price[0].expiration_date) {
                const expDate = itemSellData.price[0].expiration_date.toDate();
                if ((expDate.getTime() - this.props.dateNow) < 0) {
                  cart.deletedItem = true;
                  cart.deletedText = '価格有効期限切れ要見積';
                  item.deletedItem = true;
                  item.deletedText = '価格有効期限切れ要見積';
                } else {
                  item.price = itemSellData.price[0].price;
                }
              } else {
                item.price = itemSellData.price[0].price;
              }

              if (!item.deletedItem) {
                updateItemFromSellData(item, itemSellData);
              }
            }));
          }
        }
      }
      this.setState({ carts: cData, loading: false });
    } catch (error) {
      console.error("Error fetching carts:", error);
      this.setState({ loading: false });
    }
  }

  addCart = async (cartId) => {
    const { db, user, org, data, type } = this.props;
    let { carts } = this.state;
    
    if (!carts[cartId]) {
      carts[cartId] = { items: [] };
    }
    
    let cart = carts[cartId].items || [];
    const date = firebase.firestore.Timestamp.fromDate(new Date());
    const itemsToAdd = Array.isArray(data) ? data : [data];

    itemsToAdd.forEach(v => {
      const itemName = v['P4CLOUD商品名'] || '';
      const existing = cart.find(it => it.name === itemName);
      if (!existing) {
        cart.push({
          name: itemName,
          maker: v['正式メーカー名'] || '',
          code: v['販売企業商品コード'] || '',
          sellercode: v['仕入先事業所コード'] || '',
          sellername: v['仕入先事業所名'] || '',
          makeredicode: v['仕入先EDIコード商品コード'] || '',
          makerordercode: v['仕入先発注コード'] || '',
          price: v['price']?.[0]?.['price'] || 0,
          tax: v['消費税率'] || 0,
          id: v.id || v.objectID,
          count: 1,
          update: date,
        });
      } else {
        existing.count += 1;
        existing.update = date;
      }
    });

    carts[cartId].items = cart;
    carts[cartId].rejected = false;
    carts[cartId].latestUpdate = date;
    if (type === 'otasuke') {
        carts[cartId].created = carts[cartId].created || date;
        if (!carts[cartId].creatorUser) {
            carts[cartId].creatorUser = user.id;
            carts[cartId].creatorUserName = user.last_name + " " + user.first_name;
        }
    }

    const collectionName = type === 'otasuke' ? 'otasuke_carts' : 'carts';
    const cartMainRef = db.collection(collectionName).doc(user.id);
    const cartRef = cartMainRef.collection(collectionName).doc(org.id);

    try {
      await cartMainRef.set({ dummy: 'test' }, { merge: true });
      await cartRef.set({
        [cartId]: carts[cartId],
        update: date,
      }, { merge: true });
      this.props.onClose(true); // Close with "added" status
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }

  render() {
    const { isOpen, onClose, type } = this.props;
    const { carts, loading } = this.state;

    const cartList = Array.from({ length: 5 }, (_, i) => {
      const cart = carts[i] || {};
      const items = cart.items || [];
      const amount = items.reduce((sum, it) => sum + (it.deletedItem ? 0 : (it.price * it.count)), 0);
      
      let dateText = '---';
      if (cart.latestUpdate) {
          const d = cart.latestUpdate.toDate();
          dateText = `${d.getFullYear()}/${(d.getMonth()+1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
      } else if (items.length > 0) {
          const latest = Math.max(...items.map(it => it.update?.toDate().getTime() || 0));
          if (latest > 0) {
              const d = new Date(latest);
              dateText = `${d.getFullYear()}/${(d.getMonth()+1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
          }
      }

      return {
        id: i,
        name: cart.cartName || `カート${i + 1}`,
        items: items,
        amount: amount,
        date: dateText,
        deletedItem: cart.deletedItem,
        deletedText: cart.deletedText,
        requested: cart.requested
      };
    });

    return (
      <Modal
        title={
          <Space>
            <ShoppingCartOutlined />
            <Text>{type === 'otasuke' ? 'お助けカート選択' : 'カート選択'}</Text>
          </Space>
        }
        open={isOpen}
        onCancel={() => onClose(false)}
        footer={[
          <Button key="cancel" onClick={() => onClose(false)} block size="large">
            キャンセル
          </Button>
        ]}
        width="100%"
        style={{ top: 20, padding: '0 10px' }}
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto', padding: '10px 0' }}
        closeIcon={<CloseOutlined />}
      >
        <div style={{ padding: '0 15px 10px 15px' }}>
          <Text type="secondary">カートを選択してください</Text>
        </div>
        
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Spin size="large" tip="読み込み中..." />
          </div>
        ) : (
          <List
            itemLayout="horizontal"
            dataSource={cartList}
            renderItem={(item) => (
              <List.Item
                style={{ 
                    padding: '15px', 
                    borderBottom: '1px solid #f0f0f0',
                    backgroundColor: item.requested ? '#fffbe6' : 'transparent'
                }}
                actions={[
                  <Button 
                    type="primary" 
                    onClick={() => this.addCart(item.id)}
                    disabled={item.requested}
                  >
                    {item.requested ? '承認待' : '選択'}
                  </Button>
                ]}
              >
                <List.Item.Meta
                  title={
                    <Space direction="vertical" size={0}>
                      <Text strong style={{ fontSize: '1.1rem' }}>
                        {item.name}
                      </Text>
                      <Text type="secondary" style={{ fontSize: '0.8rem' }}>
                        保存日時: {item.date}
                      </Text>
                    </Space>
                  }
                  description={
                    <div style={{ marginTop: 8 }}>
                      {item.items.length > 0 ? (
                        <Space direction="vertical" size={2} style={{ width: '100%' }}>
                          {item.items.slice(0, 3).map((it, idx) => (
                            <Text key={idx} ellipsis style={{ display: 'block', fontSize: '0.85rem' }}>
                              • {it.name}
                            </Text>
                          ))}
                          {item.items.length > 3 && <Text type="secondary">ほか{item.items.length - 3}点</Text>}
                          <div style={{ marginTop: 4 }}>
                            <Text strong style={{ color: '#d32f2f' }}>
                              合計: {item.amount.toLocaleString()}円
                            </Text>
                          </div>
                          {item.deletedItem && (
                            <Text type="danger" style={{ fontSize: '0.8rem', display: 'flex', alignItems: 'center' }}>
                              <WarningOutlined style={{ marginRight: 4 }} /> {item.deletedText}
                            </Text>
                          )}
                        </Space>
                      ) : (
                        <Text type="secondary">空です</Text>
                      )}
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        )}
      </Modal>
    );
  }
}

export default MobileCartSelect;
